import React, { Fragment,useState,useEffect } from 'react';
 import Scrollbar from '../../components/scrollbar'
import { useParams } from 'react-router-dom'
import "bootstrap-icons/font/bootstrap-icons.css"
import RelatedProject from './related';
 import Logo from '../../images/logo.svg'
import Footer from '../../components/footer';
import Navbar2 from '../../components/Navbar2'
import SliderProject from '../../components/SliderProject';
import { doc, getDoc,db } from '../../api/firebaseConfig';
import { Helmet } from 'react-helmet-async';

const ProjectSinglePage = (props) => {
    const { id } = useParams()
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(!showModal);

    const [imagesLoaded, setImagesLoaded] = useState(false); // Track image loading state

    const [post, setPost] = useState(null);
    const amenityIcons = {
        caméras: "bi-camera-video",
        climatisation: "bi-snow",
        cuisine: "bi-house-door",
        detecteurFumee: "bi-exclamation-triangle",
        detecteurMonoxyde: "bi-exclamation-diamond",
        laveLinge: "bi-droplet",
        piscine: "bi-water",
        tv: "bi-tv",
        wifi: "bi-wifi",
      };




    useEffect(() => {
        const fetchPostDetail = async () => {
          try {
            const docRef = doc(db, "blogPosts", id); // Reference to the specific post
            const docSnap = await getDoc(docRef);
            
            if (docSnap.exists()) {
              setPost(docSnap.data()); // Set the post data in state
              console.log(post)

            } else {
              console.log("No such document!");
            }
          } catch (error) {
            console.error("Error fetching post details: ", error);
          }
        };
    
        fetchPostDetail();
         
      }, [id]); // Re-run when the ID changes
      function openWhatsAppChat(postTitle) {
        const phoneNumber = "+212705749209"; // Your phone number
        const message = `Je veux savoir plus de détails à propos du riad ${postTitle}`; // Custom message with post title
      
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
      }
      
      useEffect(() => {
        if (post) {
          console.log(post)

            const images = [...post.imagecarrousel, post.imageprincipale, ...post.zoneSpecifique.salon, ...post.zoneSpecifique.chambreDeNuit, ...post.zoneSpecifique.salleDeBain];
            const totalImages = images.length;
            let loadedImages = 0;

            // Check if images are loaded
            const onImageLoad = () => {
                loadedImages++;
                if (loadedImages === totalImages) {
                    setImagesLoaded(true); // All images are loaded
                }
            };

            images.forEach((imageUrl) => {
                const img = new Image();
                img.src = imageUrl;
                img.onload = onImageLoad;
            });
        }
    }, [post]);
      

      const truncatedDescription = post?.description
  .split(" ")
  .slice(0, 60)
  .join(" ") + (post?.description.split(" ").length > 60 ? "..." : "");


    // const projectDetails = Projects.find(item => item.Id === id)
    if (!post || !imagesLoaded) return <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100vh' }}>
    <img src={Logo} alt="Logo" style={{ width: '100px', marginBottom: '20px' }} />
    <div className="spinner-border text-warning" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>

    
    return (
        <Fragment>
          <Helmet>
      <title>{post.title} - Get Riad</title>
      <meta name="description" content={post.description} />
      <meta name="keywords" content="Riads, Morocco, Hotels, Travel, Marrakech, Luxury Riads in Marrakech, Best Riads in Morocco, Affordable Riads in Marrakech, Marrakech Hotels, Traditional Moroccan Riads, Morocco Travel Guide, Stay in a Riad Marrakech, Riad Renovation Marrakech, Boutique Hotels Marrakech, Luxury Hotels Marrakech, Best Places to Stay in Morocco, Moroccan Hotels with Pool, Exploring Marrakech Riads, Authentic Morocco Travel, Top Hotels in Marrakech, Riad Accommodation Marrakech, Marrakech Travel Deals, Best Riads for Families in Marrakech, Morocco Vacation Packages, Marrakech City Tours and Riads, Hidden Gems in Marrakech, Morocco Honeymoon Packages, Traditional Moroccan Accommodation, Book Riads in Marrakech Online, Marrakech Boutique Hotels with Character" />

      <meta property="og:title" content={post.title} />
      <meta property="og:description" content={post.description} />
      <meta property="og:image" content={post.imageprincipale} />
    </Helmet>
<Navbar2 Logo={Logo} hclass={'wpo-header-style-3'}/>
           
           { /*<PageTitle pageTitle={projectDetails.title} pagesub={'Project'} /> */}

            <SliderProject key={1} isCarrousel={true} title={post.title} imagecarrousel={post.imagecarrousel}  />
            <div className="wpo-project-single-area mt-3 ">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-12">
                            <div className="wpo-project-single-wrap">
                                <div className="wpo-project-single-item">
                                    <div className="row align-items-center">
                                        <div className="row">
                                            <div className="wpo-project-single-title ">
                                            <div className="row mb-4 justify-content-around align-items-center mb-2 d-flex">
  <div className="col-auto d-flex align-items-center h-100">
    <h3 className="m-0">{post.title}</h3>
  </div>
  <div className="col-auto d-flex align-items-center h-100">
    {post.estVendu ? (
      <button onClick={() => {}} disabled className="theme-btn">
        Vendu
      </button>
    ) : (
      <button onClick={() => openWhatsAppChat(post.title)} className="theme-btn">
        À Vendre
      </button>
    )}
  </div>

</div>

                                                                        
                                                <div className="row">
  <div className="col-lg-3 col-md-6 col-sm-6 d-flex align-items-center mb-2">
    <i className="bi bi-people-fill me-2" style={{ color: '#ff8051' }}></i>
    <span className="fw-bold" style={{ color: '#0D0845' }}>
      {post.voyageurs} voyageurs
    </span>
  </div>
  <div className="col-lg-3 col-md-6 col-sm-6 d-flex align-items-center mb-2">
    <i className="bi bi-door-closed-fill me-2" style={{ color: '#ff8051' }}></i>
    <span className="fw-bold" style={{ color: '#0D0845' }}>
      {post.chambres} chambres
    </span>
  </div>
  <div className="col-lg-3 col-md-6 col-sm-6 d-flex align-items-center mb-2">
    <i className="bi bi-moon-fill me-2" style={{ color: '#ff8051' }}></i>
    <span className="fw-bold" style={{ color: '#0D0845' }}>
      {post.lits} lits
    </span>
  </div>
  <div className="col-lg-3 col-md-6 col-sm-6 d-flex align-items-center mb-2">
    <i className="bi bi-droplet-fill me-2" style={{ color: '#ff8051' }}></i>
    <span className="fw-bold" style={{ color: '#0D0845' }}>
      {post.sallesDeBain} salles de bain
    </span>
  </div>
</div>
                                            </div>
                                          
                                            <p>
        {truncatedDescription}{" "}
        {post.description.split(" ").length > 60 && (
          <button className="btn btn-link p-0" onClick={toggleModal}>
            Lire la suite
          </button>
        )}
      </p>

      {/* Bootstrap Modal */}
      <div
        className={`modal fade ${showModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background overlay
            position: "fixed", // Fixed position to stay on top of everything else
            top: "0", // Full height of the viewport
            left: "0", // Full width of the viewport
            right: "0",
            bottom: "0",
            zIndex: 9999, // Ensure it appears above other content
            width: "100%", // Optional: set to full width if needed
            height: "100%", // Optional: set to full height if needed
          }}
      >
        <div className="modal-dialog modal-lg" role="document" style={{
      position: "absolute", // Absolute positioning for centering
      top: "60%", // Vertically center the modal
      left: "50%", // Horizontally center the modal
      transform: "translate(-50%, -50%)", // Adjust for accurate centering
      zIndex: 1000, // Ensure modal content is above the overlay
      width: "80%", // Optional: set to full width if needed
      height: "100%", // Optional: set to full height if needed
      
    }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Description complète</h5>
              <button type="button" className="btn-close" onClick={toggleModal}></button>
            </div>
            <div className="modal-body">
              <p>{post.description}</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Background Click to Close */}
      {showModal && <div className="modal-backdrop fade show" onClick={toggleModal}></div>}
    
                                            { /* <p>{projectDetails.section1.description1}</p> */}
                                            </div>
                                        
                                    </div>
                                    <div className="wpo-project-single-main-img">
                                        <center>
                                        <img src={post.imageprincipale} width={"100%"}  alt={post.title}/>
                                        </center>
                                        
                                    </div>
                                    <div className=" ">
                                        <div className="row">
                                        <div className=" ">
                                                <div className="wpo-project-single-title">
                                                    <h3>Les Séjours</h3>
                                                </div>
                                                <SliderProject key={2} isCarrousel={false} title={`les chambres de nuit du ${post.title}`} imagecarrousel={post.zoneSpecifique.salon}  />
                                            </div>
                                            <div className=" ">
                                                <div className="wpo-project-single-title  mt-4">
                                                    <h3>Les Chambres De Nuit</h3>
                                                </div>
                                                <SliderProject key={2} isCarrousel={false} title={`les chambres de nuit du ${post.title}`} imagecarrousel={post.zoneSpecifique.chambreDeNuit}  />
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className=" ">
                                        <div className="row">

                                      

                                            <div className=" ">
                                                <div className="wpo-project-single-title mt-4">
                                                    <h3>Les Salles de Bain</h3>
                                                </div>
                                                <SliderProject key={2} isCarrousel={false} title={`les chambres de nuit du ${post.title}`} imagecarrousel={post.zoneSpecifique.salleDeBain}  />
                                            </div>
                                             
                                            <div className="d-flex justify-content-center">
                                            <div className="col-lg-7 mt-4 mb-4">
                                                <div className="wpo-project-single-item-quote">
                                                <div className="wpo-project-single-title">
                                                    <h3>Ce que propose ce Riad</h3>
                                                </div>
                                                <div className="d-flex justify-content-center">
                                                <ul className="list-unstyled mt-3">
  {Object.entries(post.amenities)
    .sort(([, a], [, b]) => b - a) // Sort: true values first, then false
    .map(([key, value]) => {
      const amenityLabels = {
        caméras: "Caméras de surveillance",
        climatisation: "Climatisation",
        cuisine: "Cuisine équipée",
        detecteurFumee: "Détecteur de fumée",
        detecteurMonoxyde: "Détecteur de monoxyde de carbone",
        laveLinge: "Lave-linge",
        piscine: "Piscine",
        tv: "Télévision",
        wifi: "Wi-Fi",
      };

      return (
        <li key={key} className="d-flex align-items-center mb-2">
          <i className={`bi ${amenityIcons[key]} me-2`} />
          <span className={value ? "" : "text-decoration-line-through"}>
            {amenityLabels[key]}
          </span>
        </li>
      );
    })}
</ul>
</div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <section className="wpo-contact-map-section">
                                    <div className="wpo-project-single-title mt-4">
                                                    <h3>Où se trouve ce Riad?</h3>
                                                </div>
                <div className="wpo-contact-map">
                 
                                                   
                                                
                    <iframe 
                        src={post.location}  
                        title={`Localisation de ${post.title}`}
                        width="600" 
                        height="450" 
                        style={{ border: "0" }}  
                        allowFullScreen  
                        loading="lazy"  
                        referrerPolicy="no-referrer-when-downgrade">
                    </iframe>
            </div>
            </section>
                                    
                                     <div className='mt-4'>
                                    <RelatedProject/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer ftClass={'wpo-site-footer-s2'}/>
            <Scrollbar />
        </Fragment>
    )
};
export default ProjectSinglePage;
